import { Button, Stack, Typography } from '@mui/material';
import { FC } from 'react';

type ParentAgreementCustomerDetailsProps = {
  label: string;
  value: string;
  onClick?: () => void;
};

export const ParentAgreementCustomerDetails: FC<ParentAgreementCustomerDetailsProps> = ({
  label,
  value,
  onClick,
}) => {
  const valueContent = (
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {value}
    </Typography>
  );

  return (
    <Stack direction="column" sx={{
      gap: "4px"
    }}>
      {onClick ? (
        <Button variant="text" onClick={onClick} sx={{ padding: '0', justifyContent: 'flex-start' }}>
          {valueContent}
        </Button>
      ) : (
        valueContent
      )}
      <Typography variant="body2" sx={{
        color: "text.secondary"
      }}>
        {label}
      </Typography>
    </Stack>
  );
};
